// Name normalization for search and matching.

export function slug(s: string): string {
  return s
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "")  // strip diacritics
    .toLowerCase()
    .replace(/ø/g, "o")
    .replace(/æ/g, "ae")
    .replace(/ß/g, "ss")
    .replace(/∞/g, "")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();
}

export function searchMatches(query: string, target: string): boolean {
  const q = slug(query);
  if (!q) return true;
  return slug(target).includes(q);
}
